import { render, staticRenderFns } from "./CompositionsBranch.vue?vue&type=template&id=7e9e4441&scoped=true"
import script from "./CompositionsBranch.vue?vue&type=script&lang=js"
export * from "./CompositionsBranch.vue?vue&type=script&lang=js"
import style0 from "./CompositionsBranch.vue?vue&type=style&index=0&id=7e9e4441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9e4441",
  null
  
)

export default component.exports